require('./creditCardOffer.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ components
const CheckBox = require('components/checkBox/checkBox');

const CreditCardOffer = props => {
    const { additionalContent, label, onChange, subLabel, disabled } = props;
    const checkboxList = [
        {
            label: <div className="credit-card-offer__label">{label}</div>,
            model: 'userProfile.creditCardOffer_accepted',
            onChange: onChange,
        },
    ];

    return (
        <div className="credit-card-offer">
            <div className="row">
                <div className="col-xs-12">
                    <CheckBox
                        checkBoxList={checkboxList}
                        profileModel="userProfile.creditCardOffer"
                        disabled={disabled}
                        remarkable
                        {...props}
                    />
                </div>
                <div className="col-xs-12">{additionalContent}</div>
                <div className="col-xs-12">{subLabel}</div>
            </div>
        </div>
    );
};

CreditCardOffer.propTypes = {
    label: PropTypes.any.isRequired,
    additionalContent: PropTypes.any,
    subLabel: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.any,
};

module.exports = CreditCardOffer;
